import useMediaQuery from "../../hooks/useMediaQuery";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import useQueryParams from "../../hooks/useQueryParams";
import styles from "./ui.module.scss";
import { useTranslation } from "react-i18next";
import { smoothScroll } from "../../utils/helpers";

export const Paginator = ({ data, itemsPerPage, onPageChange }) => {
  const mobile = useMediaQuery(`( maxWidth: 768px)`);
  const { t } = useTranslation();

  const [itemOffset, setItemOffset] = useState(0);
  const [page, setParams] = useQueryParams(["page"]);

  useEffect(() => {
    if (!page) {
      setParams({ page: 1 });
    } else {
      const pageNumber = parseInt(page, 10) || 1;
      const newOffset = (pageNumber - 1) * itemsPerPage;
      setItemOffset(newOffset);
    }
  }, [page, itemsPerPage, setParams]);

  useEffect(() => {
    const pageCount = Math.ceil(data?.length / itemsPerPage);
    if (page > pageCount) {
      setParams({ page: pageCount });
    }
    onPageChange(itemOffset, itemsPerPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, page, itemsPerPage, itemOffset]);

  const pageCount = Math.ceil(data?.length / itemsPerPage);

  const arrowPrev = !mobile ? t("prev") : "<";
  const arrowNext = !mobile ? t("next") : ">";

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setParams({ page: newPage });
    smoothScroll();
  };

  return (
    <ReactPaginate
      breakLabel="..."
      onPageChange={handlePageClick}
      pageRangeDisplayed={1}
      pageCount={pageCount}
      previousLabel={page > 1 ? arrowPrev : null}
      nextLabel={page < pageCount ? arrowNext : null}
      renderOnZeroPageCount={null}
      containerClassName={styles.pagination}
      activeClassName={styles.paginationActive}
      forcePage={page - 1}
    />
  );
};
